import React from 'react';
import styles from './BulkAction.module.scss';
import { Button, Space } from 'antd';

const BulkAction = props => {
    const { bulkActions, className, checkedRows } = props;

    return (
        <Space className={styles.container}>
            {bulkActions.map(action => (
                <Button className={className} {...action.buttonProps} onClick={() => action.handler(checkedRows)}>
                    {action.title}
                </Button>
            ))}
        </Space>
    );
};

export default BulkAction;
